import Auth from '../http/resources/authPassportHttp';
import Storage from './sessionStorage';
import makeToken from './makeToken';

const tokenServices = makeToken(Storage, Auth);

export default tokenServices;
